import { render } from "./customize-page-sheet.vue?vue&type=template&id=27239b4c"
import script from "./customize-page-sheet.vue?vue&type=script&lang=js"
export * from "./customize-page-sheet.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/miqrositio/miqrositio_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__